import React, { useState } from 'react';
import { Calendar, MapPin, ChevronRight, ChevronLeft, Search } from 'lucide-react';
import Navbar from '../components/accueil/Navbar';
import PageBanner from './Banner';
import Footer from '../components/accueil/Footer';
import ChatWidget from '../components/accueil/ChatWidget';
import useGlobale from '../components/global';

const EvenementScreen = () => {
  const { authenticated, user, logout } = useGlobale();
  const [searchTerm, setSearchTerm] = useState('');
  const [currentSlide, setCurrentSlide] = useState(0);

  const events = [
    {
      id: 1,
      title: "21ème Séminaire du FRATEL",
      date: { start: "2024-05-21", end: "2024-05-22" },
      description: "Le séminaire 2024 du réseau aura lieu au Niger les mardi 21 et mercredi 22 mai 2024. Le thème...",
      image: "/images/seminaire.jpg",
      status: "DELAI DEPASSE"
    },
    {
      id: 2,
      title: "Forum d'investissement de l'AES",
      date: { start: "2024-05-04", end: "2024-05-06" },
      description: "Le Forum d'Investissement de l'AES est une plateforme stratégique qui réunit les acteurs...",
      image: "/images/aes.jpg",
      status: "DELAI DEPASSE"
    },
    {
      id: 3,
      title: "SMPRCP",
      date: { start: "2024-02-28", end: "2024-03-08" },
      description: "Le Séminaire Régional sur les programmes de maintenance (SMP) et programme de fiabilité...",
      image: "/images/at.png",
      status: "DELAI DEPASSE"
    },
    {
      id: 4,
      title: "21ème Séminaire du FRATEL",
      date: { start: "2024-05-21", end: "2024-05-22" },
      description: "Le séminaire 2024 du réseau aura lieu au Niger les mardi 21 et mercredi 22 mai 2024. Le thème...",
      image: "/images/seminaire.jpg",
      status: "DELAI DEPASSE"
    }
  ];

  const nextSlide = () => {
    setCurrentSlide((old) => (old + 3 >= events.length ? 0 : old + 3));
  };

  const prevSlide = () => {
    setCurrentSlide((old) => (old - 3 < 0 ? Math.max(0, events.length - 3) : old - 3));
  };

  const filteredEvents = events.filter(event =>
    event.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    event.description.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <>
      <Navbar authenticated={authenticated} user={user} logout={logout} />
      <PageBanner currentPage="Événements" />

      {/* Section Hero */}
      <div className="bg-gray-50 py-16">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <div className="md:w-1/2 mb-8 md:mb-0">
              <h1 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4">
                Découvrez le Niger pendant votre séjour
              </h1>
              <p className="text-gray-600 text-lg mb-8">
                Venez découvrir notre sélection d'adresses locales et/ou prestigieuses ainsi que les activités à vivre ou à revivre
              </p>
              <button className="bg-blue-700 text-white px-6 py-3 rounded-lg font-medium hover:bg-blue-800 transition-colors">
                PREPAREZ VOTRE VOYAGE
              </button>
            </div>
            <div className="md:w-1/2 flex justify-center">
              <img
                src="images/voyage.png"
                alt="Voyageurs"
                className="w-full max-w-md h-auto"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Section Événements */}
      <div className="py-12 bg-white">
        <div className="container mx-auto px-4">
          {/* Barre de recherche */}
          <div className="max-w-2xl mx-auto mb-12">
            <div className="relative">
              <input
                type="text"
                placeholder="Rechercher un événement..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full px-4 py-3 pl-12 border border-gray-300 rounded-xl
                          focus:ring-2 focus:ring-blue-500 focus:border-blue-500
                          transition-all duration-200 ease-in-out"
              />
              <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
            </div>
          </div>

          {/* Slider d'événements */}
          <div className="relative">
            <div className="overflow-hidden">
              <div
                className="flex transition-transform duration-500 ease-in-out"
                style={{ transform: `translateX(-${currentSlide * (100 / 3)}%)` }}
              >
                {filteredEvents.map((event, index) => (
                  <div key={event.id} className="w-full md:w-1/3 flex-shrink-0 px-4">
                    <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
                      {/* Image de l'événement */}
                      <div className="relative h-48">
                        <img
                          src={event.image}
                          alt={event.title}
                          className="w-full h-full object-cover"
                        />
                      </div>

                      {/* Contenu */}
                      <div className="p-6">
                        <h3 className="text-xl font-bold text-gray-900 mb-2">
                          {event.title}
                        </h3>

                        {/* Dates */}
                        <div className="flex items-center text-gray-500 text-sm mb-3">
                          <Calendar size={16} className="mr-2" />
                          <span>
                            Du {new Date(event.date.start).toLocaleDateString('fr-FR')} au{' '}
                            {new Date(event.date.end).toLocaleDateString('fr-FR')}
                          </span>
                        </div>

                        {/* Description */}
                        <p className="text-gray-600 mb-4">
                          {event.description}
                        </p>

                        {/* Boutons */}
                        <div className="flex justify-between items-center">
                          <a
                            href="#"
                            className="text-blue-600 hover:text-blue-700 font-medium flex items-center"
                          >
                            Voir plus
                            <ChevronRight size={16} className="ml-1" />
                          </a>
                          <span className="px-4 py-1 bg-red-100 text-red-600 rounded-full text-sm">
                            {event.status}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Boutons de navigation */}
            <button
              onClick={prevSlide}
              className="absolute left-0 top-1/2 transform -translate-y-1/2 -translate-x-6
                       bg-white rounded-full p-2 shadow-lg hover:bg-gray-100
                       focus:outline-none focus:ring-2 focus:ring-blue-500"
              disabled={currentSlide === 0}
            >
              <ChevronLeft size={24} />
            </button>
            <button
              onClick={nextSlide}
              className="absolute right-0 top-1/2 transform -translate-y-1/2 translate-x-6
                       bg-white rounded-full p-2 shadow-lg hover:bg-gray-100
                       focus:outline-none focus:ring-2 focus:ring-blue-500"
              disabled={currentSlide + 3 >= filteredEvents.length}
            >
              <ChevronRight size={24} />
            </button>

            {/* Indicateurs de slides */}
            <div className="flex justify-center mt-8 space-x-2">
              {Array.from({ length: Math.ceil(filteredEvents.length / 3) }).map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentSlide(index * 3)}
                  className={`w-3 h-3 rounded-full transition-colors ${currentSlide === index * 3 ? 'bg-blue-600' : 'bg-gray-300'
                    }`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>

      <Footer />
      <ChatWidget />
    </>
  );
};

export default EvenementScreen;
